
export { useNCWFallbackBalance } from "/home/runner/work/capsicum/capsicum/libs/features/nc-wallet/shared/src/hooks/components/useNCWFallbackBalance.ts"